import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import * as Util from '../../../util';
import ShelfType from '../ShelfType';
import { connectToUser } from '../../User/containers/UserDataStore';

const ShelvesContext = React.createContext();

const name = 'shelvesDataStore';

export const useShelves = () => React.useContext(ShelvesContext);

export const connectToShelves = makeConnectTo(ShelvesContext, name);

class ShelvesDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		userDataStore: PropTypes.object,
	};

	state = {
		shelves: [],
		selectedMenuOption: ShelfType.AnticipatingMild.key,
		isLoading: true,
	};

	render() {
		const shelvesDataStore = this.getStore();
		return (
			<ShelvesContext.Provider value={shelvesDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(shelvesDataStore)
					: this.props.children}
			</ShelvesContext.Provider>
		);
	}

	componentDidMount() {
		const { isAnonymous } = this.props.userDataStore;
		if (!isAnonymous()) {
			this.fetchShelves();
		} else {
			this.setState({ isLoading: false });
		}
	}

	componentWillUnmount() {
		if (this.shelvesFetch && this.shelvesFetch.cancel) {
			this.shelvesFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshShelves(),
		setShelves: (skus, shelf) => this.setShelves(skus, shelf),
		setSelectedMenuOption: selectedMenuOption =>
			this.setSelectedMenuOption(selectedMenuOption),
	});

	refreshShelves = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchShelves();
		return this.shelvesFetch.promise;
	};

	fetchShelves = () => {
		const request = api.cancelableGet(`/api/v1/me/shelves`);
		request.promise.then(this.cacheApiResponse);
		this.shelvesFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const shelves = apiResponse && Util.createTitleObject(apiResponse);
		this.setState({ shelves: shelves || [], isLoading: false });
	};

	getShelves = apiResponse => {
		const {
			shelves,
			products,
			downloadableSkus,
			requestableSkus,
		} = apiResponse;
		if (shelves && shelves[0].shelf !== 'Clear') {
			return shelves.map(shelf => {
				const product =
					products && products.filter(pr => pr.sku === shelf.sku)[0];
				const isRequestable =
					requestableSkus &&
					requestableSkus.filter(rs => rs === shelf.sku)[0];
				const isDownloadable =
					downloadableSkus &&
					downloadableSkus.filter(dl => dl === shelf.sku)[0];
				return {
					...shelf,
					product,
					isRequestable,
					isDownloadable,
					uri:
						product &&
						product.images &&
						product.images.filter(im => im.type === 'jacketCover')
							.length > 0 &&
						product.images.filter(
							im => im.type === 'jacketCover',
						)[0].uri + '?height=450',
				};
			});
		}
	};

	setShelves = (skus, shelf) => {
		api.post(`/api/v1/me/shelves/${shelf}`, skus).then(() => {
			this.refreshShelves();
		});
	};

	setSelectedMenuOption = selectedMenuOption => {
		this.setState({ selectedMenuOption });
	};
}

export default connectToUser(ShelvesDataStore);
